import { annexureCards } from "@/lib/pdf";

export default function AnnexureGrid({ lines }) {
  const cards = annexureCards(lines);
  if (!cards.length) return null;
  const pairs = [];
  for (let i = 0; i < cards.length; i += 2) pairs.push(cards.slice(i, i + 2));
  return (
    <div className="annexure-print mt-5 pt-4 border-t-2 border-slate-800" data-testid="invoice-annexure">
      <div className="annexure-title text-sm font-bold uppercase tracking-wider mb-3">ANNEXURE – QUANTITY BREAKDOWN</div>
      {pairs.map((pair, pi) => (
        <div key={pi} className="card-row" data-testid={`annexure-card-row-${pi}`}>
          {pair.map((card, ci) => (
            <div key={ci} className="card" data-testid={`annexure-card-${card.index}-${card.tag.includes("/") ? card.tag.split("(")[1].replace(/[)/]/g, "-").trim() : "1"}`}>
              <div className="card-title" data-testid={`annexure-item-${card.index}`}>{card.tag}</div>
              <div className="card-head">
                <span className="ch-base">{card.unit}</span>
                <span className="ch-x">×</span>
                <span className="ch-pieces">Pieces</span>
                <span className="ch-sub">Subtotal</span>
              </div>
              {card.cells.map((x, r) => (
                <div key={r} className="card-cell">
                  <span className="cc-base mono">{x.base}</span>
                  <span className="cc-x">×</span>
                  <span className="cc-pieces mono">{x.mult}</span>
                  <span className="cc-sub mono">{x.sub}</span>
                </div>
              ))}
              {card.isLast && <div className="card-total" data-testid={`annexure-total-${card.index}`}>{card.total}</div>}
            </div>
          ))}
          {pair.length === 1 && <div className="card-spacer" aria-hidden="true" data-testid={`annexure-card-spacer-${pi}`} />}
        </div>
      ))}
    </div>
  );
}
